import ProductCard from 'app/javascript/components/store/ProductCard';
import type { StoreProduct } from 'app/javascript/data/storeCatalogs';

interface StoreRelatedProductsProps {
  products: StoreProduct[];
  academyName: string;
  companySlug: string;
}

// "Produtos semelhantes" on the detail page: other products from the same
// category. Renders nothing when the category has no other products.
export default function StoreRelatedProducts({ products, academyName, companySlug }: StoreRelatedProductsProps) {
  if (products.length === 0) return null;

  return (
    <section className="mt-14 border-t border-border/40 pt-10 sm:mt-20 sm:pt-12">
      <h2 className="mb-6 font-bebas text-2xl uppercase tracking-[0.04em] text-foreground sm:text-3xl">
        Produtos semelhantes
      </h2>
      <div className="grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-3 lg:grid-cols-4">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} academyName={academyName} companySlug={companySlug} />
        ))}
      </div>
    </section>
  );
}
